import { useState } from 'react';
import type { Industry, Product, ProductClickHandler } from '../../types';
import {
  filterBySearch,
  filterProductsByIndustry,
  toDisplayProducts,
  type ViewMode,
} from '../../lib/products';
import { ProductGrid } from '../ProductGrid/ProductGrid';
import { Toolbar } from '../Toolbar/Toolbar';
import { IndustrySidebar } from './components/IndustrySidebar/IndustrySidebar';
import styles from './AdminView.module.css';

interface AdminViewProps {
  products: Product[];
  industries: Industry[];
  onProductClick?: ProductClickHandler;
}

/** Internal/admin view: an industry sidebar filtering a flat product grid. */
export function AdminView({ products, industries, onProductClick }: AdminViewProps) {
  const [search, setSearch] = useState('');
  const [activeIndustry, setActiveIndustry] = useState('');
  const [viewMode, setViewMode] = useState<ViewMode>('category');

  const industry = industries.find((i) => i.code === activeIndustry);
  const source = activeIndustry ? filterProductsByIndustry(products, industry) : products;
  const filtered = filterBySearch(toDisplayProducts(source, viewMode), search);

  return (
    <div className={styles.admin}>
      <IndustrySidebar
        industries={industries}
        active={activeIndustry}
        allCount={products.length}
        onSelect={setActiveIndustry}
      />
      <div className={styles.content}>
        <Toolbar
          search={search}
          onSearchChange={setSearch}
          count={filtered.length}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
        />
        <ProductGrid products={filtered} flush onProductClick={onProductClick} />
      </div>
    </div>
  );
}
